import createStore from "astrid-helpers/src/createStore";
export const [getSelection, setInternalSelection, useSelection, onSelection] = createStore();
export function setSelection(selection) {
  if (!selection) {
    window.getSelection().removeAllRanges();
  }
  return setInternalSelection(selection);
}
//# sourceMappingURL=selection.js.map